import { makeStyles } from '@mui/styles';
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  reasoningContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },
  reasoningSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  criteriaContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  criteriaItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    paddingBottom: '12px',
    borderBottom: `1px solid ${colors.neutral100}`,
  },
});
